import { Component, Input, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import { LowerBound } from 'src/app/core/services/lowerBound.service';
import { ChartService } from 'src/app/core/services/waterfallChart.service';

@Component({
  selector: 'app-customer-margin-realization-chart',
  templateUrl: './customer-margin-realization-chart.component.html',
  styleUrls: ['./customer-margin-realization-chart.component.scss'],
})
export class CustomerMarginRealizationChartComponent implements OnInit {
  @Input() marginReal: any = {};
  chartOption: EChartsOption = {};
  data: any[] = [];
  positive: any = [];
  negative: any = [];
  sales_data: any = [];

  min: number = 0;
  max: number = 0;
  start: any = [];
  reduce: number = 0;
  startingPoint: number = 0;
  base: number = 0;
  scaleBreak = true;
  private waterfallRows: any[][] = [];

  constructor(private chart: ChartService, private lowerBound: LowerBound) { }

  ngOnInit(): void {
    let data: any[] = [];
    data[0] = this.marginReal.prior_period_margin;
    data[1] = this.marginReal.price;
    data[2] = this.marginReal.mix_impact;
    data[3] = this.marginReal.volume_margin;
    data[4] = this.marginReal.acquisition_margin;
    data[5] = this.marginReal.attrition_margin;
    data[6] = this.marginReal.cost_margin;
    data[7] = this.marginReal.forex_margin;
    data[8] = this.marginReal.current_period_margin;
    this.data = data;
    this.base = 0;
    const waterfallData = [
      [
        'barLabel',
        'barStartValue',
        'barEndValue',
        'referenceDatapoint',
        'index',
      ],

      ['2025', this.base, this.data[0], 2, 0],

      ['Price', this.data[0], this.data[0] + this.data[1]],

      [
        'Mix',
        this.data[0] + this.data[1],
        this.data[0] + this.data[1] + this.data[2],
      ],
      [
        'Volume',
        this.data[0] + this.data[1] + this.data[2],
        this.data[0] + this.data[1] + this.data[2] + this.data[3],
      ],
      [
        'Acquisition',
        this.data[0] + this.data[1] + this.data[2] + this.data[3],
        this.data[0] +
        this.data[1] +
        this.data[2] +
        this.data[3] +
        this.data[4],
      ],
      [
        'Attrition',
        this.data[0] + this.data[1] + this.data[2] + this.data[3] + this.data[4],
        this.data[0] +
        this.data[1] +
        this.data[2] +
        this.data[3] +
        this.data[4] +
        this.data[5]
      ],
      [
        'Cost Margin',
        this.data[0] + 
        this.data[1] + 
        this.data[2] + 
        this.data[3] + 
        this.data[4] +
        this.data[5],
        this.data[0] +
        this.data[1] +
        this.data[2] +
        this.data[3] +
        this.data[4] +
        this.data[5] +
        this.data[6]
      ],
      [
        'FX',
        this.data[0] + 
        this.data[1] + 
        this.data[2] + 
        this.data[3] + 
        this.data[4] +
        this.data[5] +
        this.data[6],
        this.data[0] +
        this.data[1] +
        this.data[2] +
        this.data[3] +
        this.data[4] +
        this.data[5] +
        this.data[6] +
        this.data[7]
      ],

      ['2026', this.base, this.data[8], 2, 0],
    ];
    this.waterfallRows = waterfallData;
    this.renderChart();
  }

  onScaleBreakToggle(enabled: boolean): void {
    this.scaleBreak = enabled;
    this.renderChart();
  }

  private renderChart(): void {
    const prepared = this.lowerBound.prepareSalesWaterfall(
      this.waterfallRows,
      this.scaleBreak
    );
    this.startingPoint = prepared.startingPoint;
    this.base = prepared.startingPoint;
    this.chartOption = this.chart.loadWaterFall(
      prepared.data,
      prepared.startingPoint,
      'YOY Margin Realization',
      undefined,
      this.scaleBreak ? 2 : 1
    );
  }
}
